import * as React from 'react';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import PageContent from '../../components/layout/PageContent';
import CustomForm from '../../components/form/CustomForm';
import { enums, enumDictionary } from './helper';

const EditBanner = ({
	location: { state: { id = null } = {} } = {},
}) => {

	const [ fields, setFields ] = React.useState([]);

	const history = useHistory();

	React.useEffect(() => {
		axios.get(`/api/banner/${id}`)
		.then(({ data = {} }) => {
			const { result = {  } } = data;
			const responseFields = (result?.data ?? []).map((field) => {
				if (field.key === "image") {
					return {
						...field,
						value: [{
							url: field?.value || null,
						}]
					};
				};
				if (field.key === 'logo') {
					return {
						...field,
						instance: 'string',
						enum: enums,
						enumDictionary,
					}
				};
				return {
					...field,
				};
			});
			setFields(responseFields);
		})
		.catch(err => {
			console.log(err);
		})
	}, [id]);

	const handleSubmit = (fields) => {
		axios.post(`/api/banner/${id}`, fields)
		.then(({ data }) => {
			if (data.statusCode === 200) {
				history.push('/banner');
			}
		})
		.catch(err => {
			console.log(err);
		})
	}

	const handleCancel = () => {
		history.push('/banner')
	};

	return (
		<PageContent
			background='#fff'
			subheader={{
				title: 'Сурталчилгааны мэдээлэл засах',
				background: '#fff'
			}}
		>
			<CustomForm
				fields={fields}
				onSubmit={handleSubmit}
				onCancel={handleCancel}
			/>
		</PageContent>
	)
}

export default EditBanner;